import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CORE_CONFIGURATION } from '../../core/configuration';
import { ApiModule } from './api.module';
import { BaseApiService } from './base-api.service';
import { SessionState, SessionStateModel } from '../session';
import { Store } from '@ngxs/store';
import { buildAwsApi } from '../util.class';

@Injectable({
  providedIn: ApiModule,
  deps: [BaseApiService],
})
export class NotificationsApiService {
  keyMapAWS: any;

  constructor(private http: BaseApiService, @Inject(CORE_CONFIGURATION) private config,private _store: Store) {
    const { keyMapAWS }: SessionStateModel = this._store.selectSnapshot(SessionState);
    this.keyMapAWS = keyMapAWS;
  }

  /**
    * notification api get notification
    * @param msisdn current msisdn
    */
  getNotificationSettings(msisdn: string): Observable<any> {
    const apiAWS = buildAwsApi(this.keyMapAWS,'retrieve_news_push_permission', {'msisdn': msisdn} );

    return this.http.get({
      apiBasePath: this.config.apiBasePath,
      path: apiAWS,
      awsApi: apiAWS !== null
    });
  }

  /**
    * notification api post notification
    * @param msisdn current msisdn
    * @param enable
    */
  setNotificationSettings(msisdn: string,enable: boolean): Observable<any> {
    const body = {
      msisdn: msisdn,
      status:enable,
    };
    const apiAWS = buildAwsApi(this.keyMapAWS,'update_news_push_permission', {} );
    return this.http.post({
      apiBasePath: this.config.apiBasePath,
      path: apiAWS,
      awsApi: apiAWS !== null,
      body
    });
  }

}
